module.exports = __webpack_public_path__ + "public/images/bts_hero_image_5.1fe6066ea53ee40da0cdc15ef5660e49.webp";